import { useEffect, useState } from 'react'
import { useUseFamilyAccountMeQuery } from '../graphql'
import sessionUtils from './session-utils'

interface User {
  id: string
  firstName: string
  lastName: string
  email: string
  profilePicture?: {
    small: string
  } | null
}

interface Result {
  owner: User | null
  loggedInUser: User | null
  returnUrl: string | null
  loading?: boolean
}

const NO_FAMILY_ACCOUNT: Result = { owner: null, loggedInUser: null, returnUrl: null }

const useFamilyAccount = (): Result => {
  const { data, loading, error } = useUseFamilyAccountMeQuery({ nextFetchPolicy: 'standby' })
  const [familyAccountReturnUrl, setFamilyAccountReturnUrl] = useState<string | null>(null)

  useEffect(() => {
    setFamilyAccountReturnUrl(sessionUtils.getFamilyAccountReturnUrl())
  }, [])

  if (error) {
    throw new Error(error.message)
  }

  if (!data || loading) {
    return { ...NO_FAMILY_ACCOUNT, loading }
  }

  if (!(data.me && data.me.family)) {
    return NO_FAMILY_ACCOUNT
  }

  const loggedInUser = {
    id: data.me.id,
    firstName: data.me.firstName,
    lastName: data.me.lastName,
    email: data.me.email,
    profilePicture: data.me.profilePicture,
  }

  return { owner: data.me.family.owner, loggedInUser, returnUrl: familyAccountReturnUrl }
}

export default useFamilyAccount
